import { render, staticRenderFns } from "./ModalAlterarCotacao.vue?vue&type=template&id=f165f2d6&scoped=true"
import script from "./ModalAlterarCotacao.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarCotacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarCotacao.vue?vue&type=style&index=0&id=f165f2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f165f2d6",
  null
  
)

export default component.exports